export default (url, init = {}) => {
  if (!init.headers) {
    init.headers = {};
  }
  init.headers['X-requested-With'] = 'XMLHttpRequest';
  return fetch(url, init);
};
